module.exports = __webpack_public_path__ + "static/media/Octocat.0ba2aa20.png";